var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoaded.cultures)?_c('div',{staticClass:"card mt-4"},[_c('h2',{staticClass:"card__title"},[_vm._v(_vm._s(_vm.$t('pages.history_cultureIndex.culturesTable.title', {count: _vm.culturesTable.data.length})))]),_c('data-table',{attrs:{"columns":_vm.culturesTable.columns,"data":_vm.culturesTable.data}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }